export const default_pv_data = {
	"Rooftop PV": {
		losses: 11.7
	},
	"Ground-mounted utility scale PV": {
		losses: 10.8
	},
	"Floating PV": {
		losses: 12
	}
};

export const pv_data_variables = {
	tracking: {
		label: "Tracking system",
		value: "Fixed",
		select: ["Fixed", "1 axis", "2 axis"]
	},
	azimuth: {
		optimal: true,
		label: "Azimuth"
	},
	tilt: {
		label: "Tilt of PV panels",
		optimal: true
	},
	losses: {
		label: "Losses %"
	}
};
